import { getV1PathWithOrigin } from '@/router/routesToV1'

export default {
    methods: {
        goToKeyResultPage(objectiveId, keyResultId) {
            return getV1PathWithOrigin(`/okr/objectives/key-results`, {
                objectiveId: objectiveId,
                keyResultId: keyResultId,
            })
        },
        goToObjectivePage(objectiveId) {
            return `${getV1PathWithOrigin('/okr/objectives', { objectiveId })}`
        },
    },
}
